import { useState } from "react";
import Select from "react-select";
import { usePartnerAuthority } from "src/hooks/usePartnerAuthority";
import usePathSegment from "src/hooks/usePathSegment";
import { PrivilegeCodeMenus, UnionPartnerPrivilegeCode } from "src/types/partner";

type Props = {
  placeholder?: string;
  selectOptions: Array<{
    value: string | number;
    label: string;
    isDisabled?: boolean;
    color?: string;
  }>;
  value?: string;
  name?: string;
  setStateValue: Function;
  className?: string;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  errorText?: string;
  isDisabled?: boolean;
  positionLeft?: boolean;
};

/**
 * contract2 전용 select 컴포넌트
 * disabled 상태에서 화살표 숨김 및 텍스트 중앙 정렬
 */
export const BaseSelect2 = (props: Props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  let selectedValue = null;

  if (props.value) {
    selectedValue = props.selectOptions.find((option) => String(option.value) === String(props.value));
  }

  const currentMenu = usePathSegment();
  const findSelectColor = (selectValue: string) => {
    const selectedOption = props.selectOptions?.find((option) => String(option.value) === String(selectValue));
    return selectedOption?.color || "";
  };

  const { fetchAuthorityReadonly, partnerPrivileges } = usePartnerAuthority();

  const handleMenuClose = () => {
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // 수정 권한 ("w") 유무 판단 후 select 접근
  const isAuthorityEditable = () => {
    //현재 페이지의 권한 코드 > "BASIC" | "BUILDING" | "PRODUCT" |"CS" |"CONTRACT" 등 return
    let currentPagePrivilegeCode = "";

    for (let key in PrivilegeCodeMenus) {
      const menus = PrivilegeCodeMenus[key as UnionPartnerPrivilegeCode]; //[main, monitoring,provider,building,product,workorder] 등 메뉴들
      if (menus.includes(currentMenu)) {
        currentPagePrivilegeCode = key; // BASIC, WORKORDER,PRODUCT, BUILDING 등 리턴
        break;
      }
    }

    // 파트너 권한 확인
    const partnerAuthority = partnerPrivileges.find((privilege) => privilege.code === currentPagePrivilegeCode); // {code: "WORKORDER", permissions: ["r","w","d"];} 와 같이 리턴

    //  edit 가능여부
    const editable = partnerAuthority && partnerAuthority.permissions.includes("w");
    if (editable) {
      setIsMenuOpen(true);
    } else {
      fetchAuthorityReadonly(true);
    }
  };

  return (
    <div
      className={`w-100 base-select base-select2 contract2 ${props.value && findSelectColor(props.value)} ${
        props.positionLeft ? "position-left" : ""
      }`}
    >
      <Select
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        placeholder={props?.placeholder || "선택해주세요"}
        isSearchable={false}
        value={selectedValue}
        className={`react-select-container w-100 `}
        classNamePrefix="react-select"
        onChange={(e) => {
          e && props.setStateValue(e.value);
        }}
        onMenuOpen={isAuthorityEditable}
        onMenuClose={handleMenuClose}
        menuIsOpen={isMenuOpen}
        onInputChange={toggleMenu}
        options={props.selectOptions}
        isDisabled={props.isDisabled}
      />
      {props.errorText && <p className="validation-text">{props.errorText}</p>}
    </div>
  );
};
